import { createReducer } from "@reduxjs/toolkit";
import {
  FETCH_JOB_TYPES_SUCCESS,
  ANGULAR_INIT_OTHER,
  ADD_JOB_TYPE_SUCCESS,
  EDIT_JOB_TYPE_SUCCESS,
  FETCH_ACTIVITY_LOGS_SUCCESS,
  DELETE_JOB_TYPE_SUCCESS,
  DELETE_JOB_TYPE_LOADING,
  DELETE_JOB_TYPE_FROM_EVENT_STREAM,
  FETCH_JOB_TYPE_SUCCESS,
  SET_BATCH_JOB_TYPES_SUCCESS,
} from "~/store/action_types";

const jobTypes = createReducer({}, (builder) => {
  builder
    .addMatcher(
      (action) =>
        [
          FETCH_JOB_TYPES_SUCCESS,
          FETCH_ACTIVITY_LOGS_SUCCESS,
          ANGULAR_INIT_OTHER,
          SET_BATCH_JOB_TYPES_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        if (!action.response || !action.response.entities || !action.response.entities.job_types) {
          return;
        }
        return { ...state, ...action.response.entities.job_types };
      }
    )
    .addMatcher(
      (action) => [FETCH_JOB_TYPE_SUCCESS, ADD_JOB_TYPE_SUCCESS, EDIT_JOB_TYPE_SUCCESS].includes(action.type),
      (state, action) => {
        const { response = {} } = action;
        const { result = {}, entities = {} } = response;
        const { single = {} } = result;
        state[single] = entities.job_types[single];
      }
    )
    .addMatcher(
      (action) => [SET_BATCH_JOB_TYPES_SUCCESS].includes(action.type),
      (state, action) => {
        const { response = {} } = action;
        const { result = {} } = response;
        const { deleted = {} } = result;

        if (deleted?.length > 0) {
          for (const id of deleted) {
            delete state[id];
          }
        }

        return state;
      }
    )
    .addMatcher(
      (action) =>
        [DELETE_JOB_TYPE_LOADING, DELETE_JOB_TYPE_SUCCESS, DELETE_JOB_TYPE_FROM_EVENT_STREAM].includes(action.type),
      (state, action) => {
        const { id, is_in_use = false } = action;
        const job_type = state[id];
        if (job_type) {
          if (is_in_use) {
            state[id] = { ...job_type, is_archived: true };
          } else {
            delete state[id];
          }
        }
      }
    );
});

export default jobTypes;
